import { useState } from "react";

type useFormProps = {
  callback?: () => void;
  submitCallback?: (args?: boolean) => void;
  validate: (args: any) => void;
  initState: any;
  type?: string;
};

type ResultProps = {
  handleChange: (name: string, value: string | File | number) => void;
  handleSubmit: (args: any) => void;
  updateForm: (formData: any, singleFieldToBeValidated?: any) => void;
  checkIsFormValid: () => boolean;
  form: { [key: string]: { input: string | any; err: string; type?: string } };
};

export const useForm = ({
  callback,
  validate,
  initState,
  type,
  submitCallback,
}: useFormProps): ResultProps => {
  // state
  const [form, setForm] = useState(initState);
  const [submitClick, setSubmitClick] = useState(false);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    const validatedForm: any = validate({ form, type });
    setForm(validatedForm);
    setSubmitClick(true);
    if (
      Object.keys(validatedForm).every((key) => validatedForm[key].err === "")
    ) {
      if (callback) callback();
      if (submitCallback) submitCallback(false);
    } else if (submitCallback) submitCallback(true);
    return form;
  };

  const handleChange = (name, value) => {
    const formData = { ...form };
    formData[name].input = value;

    if (submitClick) {
      const validatedForm = validate({ form, type, name });
      setForm((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          input: validatedForm[name].input,
          err: validatedForm[name].err,
        },
      }));
    } else {
      setForm(formData);
    }
  };

  const updateForm = (formData, singleFieldToBeValidated = null) => {
    let updatedForm = {};
    Object.keys(formData).forEach((name) => {
      if (formData[name]) {
        const validatedForm = validate({
          form: formData,
          type,
          name: singleFieldToBeValidated ?? name,
        });
        updatedForm = {
          ...updatedForm,
          [name]: {
            ...form[name],
            input: validatedForm[name].input,
            err: validatedForm[name].err,
          },
        };
      }
    });
    setForm((prev) => ({ ...prev, ...updatedForm }));
  };

  const checkIsFormValid = () => {
    const validatedForm: any = validate({ form, type });
    return Object.keys(validatedForm).every(
      (key) => validatedForm[key].err === ""
    );
  };

  return {
    checkIsFormValid,
    handleChange,
    handleSubmit,
    updateForm,
    form,
  };
};
